export default "__VITE_ASSET__19487320__"